import React, { useContext } from "react"
import "./dropdown.scss"
import { StaticImage } from "gatsby-plugin-image"
import { GlobalStateContext } from "../../../context/GlobalContextProvider"

const CustomDropDownMenu = (props) => {
  const {
    title,
    isOpen,
    filterName,
    onAccordionClick,
    filterList,
    isRatingsSelect,
    handleChange,
  } = props

  const { filtersObject } = useContext(GlobalStateContext)

  return (
    <div className="filterCategory">
      <div
        className="filterHead"
        onClick={() => onAccordionClick(filterName)}
      >
        <h2 className="filterCategoryTitle">{title}</h2>
        <StaticImage
          src="../../../assets/images/arrow-up.png"
          alt=""
          className={
            isOpen ? "openArrow arrow" : "closeArrow arrow"
          }
        />
      </div>
      {isOpen && (
        <div className="categoryWrapper">
          <div>
            <ul className="categoryList">
              {isRatingsSelect ? (
                <>
                  <li>
                    <input type="checkbox" />
                    <StaticImage
                      src="../../../assets/images/fivestar.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <input type="checkbox" />
                    <StaticImage
                      src="../../../assets/images/4star.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <input type="checkbox" />
                    <StaticImage
                      src="../../../assets/images/3star.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <input type="checkbox" />
                    <StaticImage
                      src="../../../assets/images/2star.png"
                      alt=""
                    />
                  </li>
                  <li>
                    <input type="checkbox" />
                    <StaticImage
                      src="../../../assets/images/1star.png"
                      alt=""
                    />
                  </li>
                </>
              ) : (
                <>
                  {filterList.map((filterCat) => (
                    <li key={filterCat.id}>
                      <input
                        type="checkbox"
                        checked={
                          filtersObject
                            ? filtersObject[
                                filterCat.infoType
                              ][filterCat.id]
                            : false
                        }
                        onChange={(e) =>
                          handleChange(
                            filterCat.infoType,
                            filterCat.id,
                            e.target.checked
                          )
                        }
                      />{" "}
                      {filterCat.name}
                    </li>
                  ))}
                </>
              )}
            </ul>
          </div>
        </div>
      )}
    </div>
  )
}

export default CustomDropDownMenu
